import React, { useContext, useEffect, useState } from 'react'
import { strCol, numCol } from '@integec/grid-tools/lib/cols'
import { getApiTargetInfo } from 'core'
import { modifierCol, modifiedDateCol } from 'core/HeaderColTypeProps'
import { connect } from 'react-redux'
import {
  getMisoMinTestDuration,
  updateMisoMinTestDuration,
  deleteMisoMinTestDuration,
  getUnitTypeInfo,
  getFuelCodeInfo,
} from 'api/pgads.js'
import { Button, Select, InputNumber } from 'antd'
import R from 'ramda'
import CommonScreen from './CommonScreen'
import { Label } from 'core/screen-util'
import { ErrorContext } from 'context'

const MisoMinTestDurationHeaders = [
  strCol({
    ident: 'standard',
    display: 'Standard',
    isKey: true,
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'unitType',
    display: 'Unit Type',
    isKey: true,
    sortOrder: 'asc',
    width: 100,
  }),
  strCol({
    ident: 'primaryFuel',
    display: 'Primary Fuel',
    isKey: true,
    sortOrder: 'asc',
    width: 100,
  }),
  numCol({
    ident: 'minTestDuration',
    display: 'Min Test Duration',
    isFiltered: true,
    sortOrder: 'asc',
    width: 150,
  }),
  modifierCol,
  modifiedDateCol,
]

const MisoMinTestDuration = ({ apiTargetInfo }) => {
  const title = 'Verification Test Duration'
  const [insertEvent, setInsertEvent] = useState(false)
  const { setError } = useContext(ErrorContext)
  const [unitTypeList, setUnitTypeList] = useState([])
  const [fuelTypeList, setFuelTypeList] = useState([])
  useEffect(
    _ => {
      getUnitTypeInfo(apiTargetInfo).fork(setError, setUnitTypeList)
      getFuelCodeInfo(apiTargetInfo).fork(setError, setFuelTypeList)
    },
    [apiTargetInfo, setError]
  )

  const insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: '200px 200px 100px 200px 100px 200px',
        gap: '5px',
      }}
    >
      <Label>Standard : </Label>
      <Select
        value={insertData.standard}
        onChange={sel => setInsertData({ ...insertData, standard: sel })}
        style={{ width: '100%' }}
      >
        <Select.Option value="MISO" key="MISO">
          MISO
        </Select.Option>
        <Select.Option value="MRO" key="MRO">
          MRO
        </Select.Option>
        <Select.Option value="RFC(MOD-24)" key="RFC(MOD-24)">
          RFC(MOD-24)
        </Select.Option>
        <Select.Option value="RFC(ECAR)" key="RFC(ECAR)">
          RFC(ECAR)
        </Select.Option>
        <Select.Option value="RFC(MAIN)" key="RFC(MAIN)">
          RFC(MAIN)
        </Select.Option>
        <Select.Option value="SERC" key="SERC">
          SERC
        </Select.Option>
      </Select>
      <Label>Unit Type :</Label>
      <Select
        value={insertData.unitType}
        onChange={sel => setInsertData({ ...insertData, unitType: sel })}
        style={{ width: '100%' }}
      >
        {R.sortBy(r => r.description)(unitTypeList).map(u => (
          <Select.Option value={u.unitCode} key={u.unitCode}>
            {u.unitCode}-{u.description}
          </Select.Option>
        ))}
      </Select>
      <Label>Primary Fuel : </Label>
      <Select
        value={insertData.primaryFuel}
        onChange={sel => setInsertData({ ...insertData, primaryFuel: sel })}
        style={{ width: '100%' }}
      >
        {R.sortBy(r => r.description)(fuelTypeList).map(u => (
          <Select.Option value={u.code} key={u.code}>
            {u.code}-{u.description}
          </Select.Option>
        ))}
        <Select.Option value="XX" key="XX">
          XX
        </Select.Option>
      </Select>
      <Label>Min Test Duration : </Label>
      <InputNumber
        value={insertData.minTestDuration}
        onChange={sel => setInsertData({ ...insertData, minTestDuration: sel })}
        style={{ width: '100%' }}
      />
      <div />
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'auto auto auto',
          gap: '5px',
          gridColumnEnd: 'span 3',
        }}
      >
        <Button type="primary" onClick={() => onAdd(true)}>
          Add
        </Button>
        <Button type="primary" onClick={() => onAdd(false)}>
          Add & Hide
        </Button>
        <Button type="danger" onClick={onCancel}>
          Cancel
        </Button>
      </div>
    </div>
  )

  return (
    <CommonScreen
      title={title}
      header={MisoMinTestDurationHeaders}
      saveTask={updateMisoMinTestDuration}
      retrieveTask={getMisoMinTestDuration}
      deleteTask={deleteMisoMinTestDuration}
      altBy={d => d.standard}
      autoRetrieve
      sortOptions={MisoMinTestDurationHeaders}
      widthOffset={330}
      insertComp={insertEvent && insertComp}
      insertCompHeight={90}
      onInsertEvent={b => setInsertEvent(b)}
    />
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
})

export default connect(mapStateToProps)(MisoMinTestDuration)
